import { render, staticRenderFns } from "./CandidateRegister.vue?vue&type=template&id=15b4743f&"
import script from "./CandidateRegister.vue?vue&type=script&lang=js&"
export * from "./CandidateRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports